import { resolveUploadMimeType } from './constants';

enum MediaType {
  Picture = 'picture',
  Video = 'video',
}

export const getMediaType = (file: File): MediaType => {
  const mimeType = resolveUploadMimeType(file);

  if (mimeType.startsWith('video/')) {
    return MediaType.Video;
  }

  if (mimeType.startsWith('image/')) {
    return MediaType.Picture;
  }

  throw new Error('Unsupported media type');
};
